import { createActions } from 'redux-actions';
import { PersonalAccidentQuote } from '@models/PersonalAccidentQuote';
import { PersonalAccidentQuoteGroup } from '@models/PersonalAccidentQuoteGroup';
import { GetAllPersonalAccidentQuoteParams } from '@apis/PersonalAccidentQuoteApi';

export type State = {
  totalQuotes?: number | null;
  personalAccidentQuoteGroups?: PersonalAccidentQuoteGroup[] | null;
  comparablePersonalAccidentQuotes: PersonalAccidentQuote[];
};

export type PersonalAccidentQuotesFetchPayload = GetAllPersonalAccidentQuoteParams;
export type CompareAddPayload = { personalAccidentQuote: PersonalAccidentQuote };
export type CompareRemovePayload = CompareAddPayload;
export type StateUpdatePayload = Partial<State>;

export const {
  personalAccidentQuotesFetch,
  compareAdd,
  compareRemove,
  compareRemoveAll,
  stateUpdate,
} = createActions(
  'PERSONAL_ACCIDENT_QUOTES_FETCH',
  'COMPARE_ADD',
  'COMPARE_REMOVE',
  'COMPARE_REMOVE_ALL',
  'STATE_UPDATE',
  {
    prefix: 'PERSONAL_ACCIDENT_QUOTE_RESULT_PAGE',
  },
);
